<template>
  <div class="lead-offers-container">
    <div class="lead-offers-body" v-if="lead_offers.length || lead_distribution_methods.length">
      <div v-if="lead_distribution_methods.length">
        <div class="lead-offers-item" v-for="(lead_distribution_method, idx) in lead_distribution_methods" :key="'lead-distribution-method-' + idx">
          <distribution-method :lead_distribution_method="lead_distribution_method" @detach-distribution-method="$emit('detach-distribution-method', $event)"></distribution-method>
          
          <hr>
        </div>
      </div>

      <div v-if="lead_offers.length">
        <div class="lead-offers-item" v-for="(lead_offer, idx) in lead_offers" :key="'lead-offer-' + idx">
          <offer :lead_offer="lead_offer" @detach-offer="$emit('detach-offer', $event)"></offer>
          
          <hr>
        </div>
      </div>
    </div>
    <div v-else>
      <p>Ce lead n'est pour le moment intéressé par aucune offre.</p>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex"
import DistributionMethod from "./DistributionMethods/Item"
import Offer from "./Offers/Item"

export default {
  name:"LeadOffers",
  props:["lead_offers", "lead_distribution_methods"],
  components:{
    DistributionMethod,
    Offer,
  }
}
</script>

<style scoped>
.lead-offers-head {
  display: flex;

}

.lead-offers-container {
  padding-top: 20px;
}

.lead-offers-body {

}

.lead-offers-item {

}

</style>



// WEBPACK FOOTER //
// client/components/CRM/LeadOffers.vue